import { EmailTemplateModel } from '@app/core/models/emails/email-template.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '@app/core/config/config.service';
import { AuthService } from '@app/core/guards/auth.service';
import { HttpService } from '@app/core/http/http.service';
import { EmailTemplateType } from '../models/emails/email-template-type.model';


@Injectable({
  providedIn: 'root'
})
export class EmailTemplateService extends HttpService {

  constructor(protected http: HttpClient, protected config: ConfigService, protected authService: AuthService) {
    super(http, config, authService, 'emailtemplates');
  }

  getEmailTemplatesByType(type?: EmailTemplateType): Observable<EmailTemplateModel[]> {
    return this.invokeGet<EmailTemplateModel[]>(`type/${type}`);
  }

  getEmailTemplateById(Id: number): Observable<EmailTemplateModel> {
    return this.getById<EmailTemplateModel>(Id);
  }

  updateEmailTemplate(Id: number, emailTemplateModel: EmailTemplateModel) {
    return this.updateById(emailTemplateModel, Id);
  }

  createEmailTemplate(emailTemplateModel: EmailTemplateModel) {
    return this.invokePost(emailTemplateModel);
  }

  deleteEmailTemplate(Id: string): Observable<any> {
    return this.deleteById(Id);
  }
}
